import { logClientCompany } from "../signals/login.signal";
import { primary } from "../signals/Theme colors.signal";
import translateText, { currentLanguage } from "../signals/language.signal";

export const getCurrencySymbol = (color, fontSize, width) => {
  const finalColor = color !== undefined ? color : primary.value;
  const finalWidth = width !== undefined ? width : "20px";
  const finalFontSize = fontSize !== undefined ? fontSize : "14px";
  const companyNumber = logClientCompany.value;
  switch (companyNumber) {
    case "01": // Saudi Arabia
      return (
        <svg
          id="Layer_1"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1124.14 1256.39"
          style={{
            width: finalWidth,
            fontSize: finalFontSize,
            display: "inline",
            marginRight: "5px",
            fill: finalColor,
          }}
        >
          <path d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z" />
          <path d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z" />
        </svg>
      );
    case "15": // Kuwait
      return (
        <span
          style={{
            marginRight: "5px",
            fontWeight: "bold",
            color: finalColor,
            fontSize: finalFontSize,
          }}
        >
          {translateText(currentLanguage.value, "CurrencyKuwaitShort")}
        </span>
      );
    case "05": // UAE
      return (
        <svg
          id="Logo"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 344.84 299.91"
          style={{
            width: finalWidth,
            fontSize: finalFontSize,
            display: "inline",
            marginRight: "5px",
            fill: finalColor,
          }}
        >
          <path d="M342.14,140.96l2.7,2.54v-7.72c0-17-11.92-30.84-26.56-30.84h-23.41C278.49,36.7,222.69,0,139.68,0c-52.86,0-59.65,0-109.71,0,0,0,15.03,12.63,15.03,52.4v52.58h-27.68c-5.38,0-10.43-2.08-14.61-6.01l-2.7-2.54v7.72c0,17.01,11.92,30.84,26.56,30.84h18.44s0,29.99,0,29.99h-27.68c-5.38,0-10.43-2.07-14.61-6.01l-2.7-2.54v7.71c0,17,11.92,30.82,26.56,30.82h18.44s0,54.89,0,54.89c0,38.65-15.03,50.06-15.03,50.06h109.71c85.62,0,139.64-36.96,155.38-104.98h32.46c5.38,0,10.43,2.07,14.61,6l2.7,2.54v-7.71c0-17-11.92-30.83-26.56-30.83h-18.9c.32-4.88.49-9.87.49-15s-.18-10.11-.51-14.99h28.17c5.37,0,10.43,2.07,14.61,6.01ZM89.96,15.01h45.86c61.7,0,97.44,27.33,108.1,89.94l-153.96.02V15.01ZM136.21,284.93h-46.26v-89.98l153.87-.02c-9.97,56.66-42.07,88.38-107.61,90ZM247.34,149.96c0,5.13-.11,10.13-.34,14.99l-157.04.02v-29.99l157.05-.02c.22,4.84.33,9.83.33,15Z" />
        </svg>
      );
    case "21": // Qatar
      return (
        <span
          style={{
            marginRight: "5px",
            fontWeight: "bold",
            color: finalColor,
            fontSize: finalFontSize,
          }}
        >
          {translateText(currentLanguage.value, "CurrencyQatarShort")}
        </span>
      );
    case "23": // Bahrain
      return (
        <span
          style={{
            marginRight: "5px",
            fontWeight: "bold",
            color: finalColor,
            fontSize: finalFontSize,
          }}
        >
          {translateText(currentLanguage.value, "CurrencyBahrainShort")}
        </span>
      );
    case "10": // Lebanon
      return (
        <span
          style={{
            marginRight: "5px",
            fontWeight: "bold",
            color: finalColor,
            fontSize: finalFontSize,
          }}
        >
          {translateText(currentLanguage.value, "CurrencyLebanonShort")}
        </span>
      );
    case "13": // Yemen
      return (
        <span
          style={{
            marginRight: "5px",
            fontWeight: "bold",
            color: finalColor,
            fontSize: finalFontSize,
          }}
        >
          {translateText(currentLanguage.value, "CurrencyYemenShort")}
        </span>
      );
    case "17": // Oman
      return (
        <span
          style={{
            marginRight: "5px",
            fontWeight: "bold",
            color: finalColor,
            fontSize: finalFontSize,
          }}
        >
          {translateText(currentLanguage.value, "CurrencyOmanShort")}
        </span>
      );
    case "31": // Jordan
      return (
        <span
          style={{
            marginRight: "5px",
            fontWeight: "bold",
            color: finalColor,
            fontSize: finalFontSize,
          }}
        >
          {translateText(currentLanguage.value, "CurrencyJordanShort")}
        </span>
      );
    default:
      return (
        <svg
          id="Layer_1"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1124.14 1256.39"
          style={{
            width: finalWidth,
            fontSize: finalFontSize,
            display: "inline",
            marginRight: "5px",
            fill: finalColor,
          }}
        >
          <path d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z" />
          <path d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z" />
        </svg>
      );
  }
};
